import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BadgeColor, BadgeComponent } from '../../shared/components/ui/badge/badge.component';
import { AdminMechanicsService } from '../../core/services/admin-mechanics.service';
import { AdminMechanic } from '../../core/models/admin.models';

@Component({
  selector: 'app-mechanics-details',
  standalone: true,
  imports: [CommonModule, BadgeComponent],
  templateUrl: './mechanics-details.component.html',
  styleUrl: './mechanics-details.component.css'
})
export class MechanicsDetailsComponent implements OnInit {

  mechanic: AdminMechanic | null = null;
  isLoading = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private mechanicsService: AdminMechanicsService
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.loadMechanic(Number(idParam));
    } else {
      this.errorMessage = 'No mechanic ID provided.';
    }
  }

  loadMechanic(id: number): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.mechanicsService.getMechanic(id).subscribe({
      next: (data) => {
        this.mechanic = data;
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load mechanic details.';
        this.isLoading = false;
      }
    });
  }

  get avatarUrl(): string {
    return this.mechanic?.avatar_url
      ?? `https://i.pravatar.cc/96?u=${this.mechanic?.id}`;
  }

  get verificationStatus(): string {
    return this.mechanic?.mechanic_profile?.is_verified ? 'Verified' : 'Pending';
  }

  get accountStatus(): string {
    return this.mechanic?.is_active ? 'Active' : 'Suspended';
  }

  get skills(): string[] {
    return this.mechanic?.mechanic_profile?.skills ?? [];
  }

  get rating(): number {
    return this.mechanic?.mechanic_profile?.average_rating ?? 0;
  }

  get totalJobs(): number {
    return this.mechanic?.mechanic_profile?.total_jobs ?? 0;
  }

  get totalEarnings(): number {
    return this.mechanic?.mechanic_profile?.total_earnings ?? 0;
  }

  get experience(): number {
    return this.mechanic?.mechanic_profile?.years_of_experience ?? 0;
  }

  get isAvailable(): boolean {
    return this.mechanic?.mechanic_profile?.is_available ?? false;
  }

  getBadgeColor(status: string): BadgeColor {
    switch (status) {
      case 'Verified':  return 'success';
      case 'Approved':  return 'success';
      case 'Active':    return 'success';
      case 'Pending':   return 'warning';
      case 'Suspended': return 'warning';
      case 'Rejected':  return 'danger' as BadgeColor;
      default: return 'primary';
    }
  }

  getStars(rating: number): number[] {
    return Array.from({ length: 5 }, (_, i) => i + 1);
  }
}
